// Packages
import styled from 'styled-components';
import tw from 'twin.macro';

export const StyledPassiveTrackingMap = styled.div.attrs({
  className: "StyledPassiveTrackingMap"
})`
  ${tw`w-full`}
  height: 327px;
`